<!-- LANDING SCREEN -->
<ng-container *ngIf="screen === 'landing'">
  <app-landing-screen (openApp)="openApp()"></app-landing-screen>
</ng-container>

<!-- MAIN APP SCREEN -->
<ng-container *ngIf="screen === 'app'">
  <div class="wells-main-container" [ngClass]="promptHome ? 'prompt-home' : 'dashboard-view'">

    <!-- LEFT SIDEBAR (overview mode) -->
    <app-nav-sidebar *ngIf="showNavSidebar" [mobileOpen]="mobileSidebarOpen" [chatHistory]="chatHistory"
      [activeHistoryId]="activeHistoryId" [activeNavItemId]="activeNavItemIdForSidebar"
      [currentUserDisplayName]="currentUserDisplayName" [loadingHistory]="loadingHistory"
      [sidebarSections]="SIDEBAR_SECTIONS" [promptHome]="promptHome" [hasMetricsAccess]="hasMetricsAccess"
      (mobileClose)="mobileSidebarOpen = false" (newChat)="newChat()" (navItemClick)="goToDashboardFromSidebar($event)"
      (historyClick)="loadChatHistoryEntry($event)" (metricsClick)="goToMetrics()">
    </app-nav-sidebar>

    <!-- FIELD VIEW SIDEBAR -->
    <ng-container *ngIf="fieldView">
      <!-- Mobile overlay backdrop -->
      <div *ngIf="mobileSidebarOpen" class="sidebar-mobile-overlay" (click)="mobileSidebarOpen = false"></div>
      <div class="sidebar-wrapper" [ngClass]="mobileSidebarOpen ? 'open' : ''"
        style="background-color:#0B2D71; padding-top: 60px;">
        <div class="sidebar-logo">
          <img src="assets/images/chevron-logo.png" alt="Chevron" />
        </div>
        <div class="sidebar-new-chat">
          <button (click)="newChat()" style="background:transparent;cursor:pointer">
            <span>+</span> New Chat
          </button>
        </div>
        <div *ngIf="hasMetricsAccess()" style="padding: 1.2vh 1vh">
          <button (click)="goToMetrics()"
            style="width: 100%; padding: 0.75rem 1rem; background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.04)); border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 0.625rem; color: white; cursor: pointer; font-size: 0.8rem; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 0.625rem; transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1); box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
            onmouseover="this.style.background='rgba(255, 255, 255, 0.12)'; this.style.borderColor='rgba(255, 255, 255, 0.35)'; this.style.boxShadow='0 4px 16px rgba(0, 0, 0, 0.2)'; this.style.transform='translateY(-2px)';"
            onmouseout="this.style.background='linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.04))'; this.style.borderColor='rgba(255, 255, 255, 0.2)'; this.style.boxShadow='0 2px 8px rgba(0, 0, 0, 0.1)'; this.style.transform='translateY(0px)';">
            <img src="assets/images/userMetrics.png" alt="Metrics"
              style="width: 1.1rem; height: 1.1rem; filter: brightness(0) invert(1); opacity: 0.9;" /> User Metrics
          </button>
        </div>

        <nav class="sidebar-nav">
          <div class="sidebar-history-section">
            <div class="history-label">Chat History</div>
            <div *ngIf="loadingHistory" class="history-loading">
              <img src="assets/images/spinner.png" alt="Loading..." class="spinner-icon" />

            </div>
            <p *ngIf="!loadingHistory && getFieldChatHistory().length === 0" class="history-empty">No field-level
              history yet.</p>
            <div class="history-list">
              <button *ngFor="let c of getFieldChatHistory()" type="button" (click)="loadChatHistoryEntry(c)"
                style="border:none;cursor:pointer"
                [style.background]="activeHistoryId === c.id ? 'rgba(255,255,255,0.1)' : 'transparent'">
                <span class="history-icon">&#x1F4AC;</span>
                <span class="history-text" [title]="c.question">{{ truncateQuestion(c.question) }}</span>
              </button>
            </div>
          </div>
        </nav>
        <div class="sidebar-user">
          <div class="user-avatar">
            <img src="assets/images/userIcon.png" alt="User" class="user-icon" />
          </div>
          <div class="user-info">
            <p class="user-name">{{ currentUserDisplayName }}</p>
            <p class="user-role">Well Engineer</p>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- FIELD VIEW MAIN CONTENT (full-width chat with inline graph) -->
    <ng-container *ngIf="fieldView">
      <div class="field-view-main" style="border-radius: 1vh;  padding-top: 60px;">
        <!-- Chat Panel -->
        <div class="chat-panel">
          <!-- Chat Header -->
          <div class="chat-header">
            <button type="button" (click)="mobileSidebarOpen = !mobileSidebarOpen" class="menu-button">
              <span class="material-icon">☰</span>
            </button>
            <div class="bot-avatar" style="background:linear-gradient(135deg, #0B2D71, #072050)">
              <img src="assets/images/sparkle.png" alt="AI" class="icon-image" />
            </div>
            <div class="header-text">
              <p class="header-title" style="margin:0">P&amp;A Insights Agent</p>
            </div>
          </div>

          <!-- Chat Messages -->
          <div #fieldChatMessages class="chat-messages" style="font-size:13px;line-height:1.6">
            <div *ngIf="messages.length === 0 && !chatLoading" class="chat-empty-state">
            </div>

            <div *ngFor="let m of messages; let msgIdx = index" class="message-row"
              [style.justifyContent]="m.role === 'user' ? 'flex-end' : 'flex-start'">
              <div *ngIf="m.role === 'assistant'" class="message-avatar"
                style="background:linear-gradient(135deg, #0B2D71, #072050)">
                <img src="assets/images/BotIcon.png" alt="Bot" class="icon-image" />
              </div>

              <!-- Field graph message -->
              <ng-container *ngIf="m.role === 'assistant' && m.fieldGraph">
                <div class="field-graph-content">
                  <div *ngIf="m.content" class="message-bubble assistant-bubble" style="font-size:13px;line-height:1.6">
                    <p *ngFor="let line of formatChatMsg(m.content)" style="margin:2px 0">{{ line }}</p>
                  </div>
                </div>
              </ng-container>

              <!-- Regular assistant message -->
              <ng-container *ngIf="m.role === 'assistant' && !m.fieldGraph">
                <div class="message-content-wrapper" style="position:relative">
                  <div *ngIf="m.isError" class="message-bubble assistant-bubble error"
                    style="font-size:13px;line-height:1.6;border-radius:1rem 1rem 1rem 0.125rem">
                    <p style="margin:0 0 6px 0; font-weight:600">&#9888;&#65039; Error:</p>
                    <div [innerHTML]="formatMarkdownToHtml(m.content)"></div>
                  </div>

                  <div *ngIf="!m.isError" class="message-content-with-feedback">
                    <div class="message-bubble assistant-bubble"
                      style="font-size:13px;line-height:1.6;border-radius:1rem 1rem 1rem 0.125rem;flex:1">
                      <div [innerHTML]="formatMarkdownToHtml(m.content)"></div>
                    </div>

                    <div *ngIf="!chatLoading && !m.isWelcomeMessage && isProperResponse(m)" class="feedback-pill"
                      style="width: max-content;">
                      <button type="button" (click)="openFeedbackModal(msgIdx, 'like')"
                        [class.active]="m.feedbackType === 'like'" class="feedback-btn"
                        [style.opacity]="m.feedbackType === 'like' ? '1' : '0.5'" title="Helpful">
                        <img src="assets/images/like.png" alt="Like" class="feedback-icon" />
                      </button>
                      <button type="button" (click)="openFeedbackModal(msgIdx, 'dislike')"
                        [class.active]="m.feedbackType === 'dislike'" class="feedback-btn"
                        [style.opacity]="m.feedbackType === 'dislike' ? '1' : '0.5'" title="Not helpful">
                        <img src="assets/images/dislike.png" alt="Dislike" class="feedback-icon" />
                      </button>
                      <div class="feedback-divider"></div>
                      <button type="button" (click)="exportResponseToPdf(msgIdx)" class="feedback-btn download"
                        style="background:none;border:none;cursor:pointer" title="Download PDF">
                        <img src="assets/images/download.png" alt="Download" class="feedback-icon" />
                      </button>
                    </div>
                  </div>

                  <div *ngIf="m.results && m.results.length > 0 && !m.isError" class="results-container">
                    <div *ngIf="m.visualization && m.visualization.viz_type !== 'kpi_cards' && m.chartOptions"
                      class="viz-toggle-bar">
                      <div class="viz-toggle-group">
                        <button (click)="toggleViewMode(m, 'table')" class="viz-toggle-btn"
                          [ngClass]="m.viewMode === 'table' ? 'active' : ''">
                          <img src="assets/images/tableIcon.png" alt="Table" class="viz-icon" />
                          Table
                        </button>
                        <button (click)="toggleViewMode(m, 'chart')" class="viz-toggle-btn"
                          [ngClass]="m.viewMode === 'chart' ? 'active' : ''">
                          <img src="assets/images/chartIcon.png" alt="Chart" class="viz-icon" />
                          Chart
                        </button>
                      </div>
                      <span class="viz-title">{{ m.visualization.title }}</span>
                    </div>

                    <div *ngIf="!m.visualization || m.viewMode === 'table'" class="results-table-wrapper"
                      [ngClass]="m.results.length > 15 ? 'scrollable' : ''">
                      <div *ngIf="m.results && m.results.length > 0" class="thin-scrollbar"
                        [ngStyle]="{'max-height': m.results.length > 15 ? '500px' : 'auto', 'overflow-y': m.results.length > 15 ? 'auto' : 'visible', 'overflow-x': 'auto', 'scrollbar-width': 'thin', 'scrollbar-color': '#0B2D71 #f3f4f6'}">
                        <table class="results-table">
                          <thead>
                            <tr style="background:#0B2D71; position: sticky; top: 0; z-index: 10;">
                              <th *ngFor="let col of resultColumns(m.results)"
                                style="font-size:11px;letter-spacing:0.03em;border-right-color:rgba(255,255,255,0.2)">
                                {{ col }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of m.results; let i = index">
                              <td *ngFor="let col of resultColumns(m.results)">
                                {{ formatCellValue(row[col]) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div *ngIf="!m.results || m.results.length === 0" class="results-empty">
                        <p>No data available to display</p>
                      </div>
                      <div class="results-footer">
                        <span>{{ m.results?.length || 0 }} row{{ (m.results?.length || 0) !== 1 ? 's' : '' }}
                          displayed</span>
                      </div>
                    </div>

                    <div *ngIf="m.visualization && m.viewMode === 'chart'" class="chart-wrapper bordered thin-scrollbar"
                      style="overflow-x:auto; overflow-y:hidden;">
                      <div [id]="'chart-export-' + msgIdx" class="chart-inner">
                        <highcharts-chart [Highcharts]="Highcharts" [options]="m.chartOptions" [oneToOne]="true"
                          [runOutsideAngular]="true" style="display:block; width:100%; height:480px;">
                        </highcharts-chart>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- User message -->
              <ng-container *ngIf="m.role === 'user'">
                <div class="message-bubble user-bubble"
                  style="background:#0B2D71;color:#fff;font-size:13px;line-height:1.6;border-radius:1rem 1rem 0.125rem 1rem">
                  {{ m.content }}
                </div>
              </ng-container>

              <div *ngIf="m.role === 'user'" class="message-avatar-sm">
                <img src="assets/images/chatUser.png" alt="User" class="icon-image-user" />
              </div>
            </div>

            <div *ngIf="chatLoading" class="loading-row">
              <div class="loading-dots">
                <div *ngFor="let j of [0,1,2]" class="dot" [style.animationDelay]="j * 150 + 'ms'"></div>
              </div>
            </div>
          </div>

          <!-- Chat Input -->
          <form class="chat-input-form" (submit)="$event.preventDefault(); handleChatSend()">
            <div class="input-wrapper">
              <input type="text" [(ngModel)]="chatDraft" name="chatInputField" placeholder="Ask a question"
                (keydown.enter)="$event.preventDefault(); handleChatSend()" />
              <button type="submit" [disabled]="chatLoading || !chatDraft.trim()" class="send-btn"
                style="border:none;cursor:pointer;background:#0B2D71;width:32px;height:32px;min-width:32px;min-height:32px;padding:0"
                aria-label="Send">
                ➤
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Feedback Survey Modal (field-level chat) -->
      <div *ngIf="showFeedbackModal" class="modal-overlay" style="background:rgba(0,0,0,0.4)">
        <div class="modal-card" style="font-family:'Inter',system-ui,sans-serif">
          <h2 class="modal-title">Quick Feedback</h2>

          <div *ngIf="feedbackError" class="modal-error">
            <p>{{ feedbackError }}</p>
          </div>

          <div class="modal-section">
            <p class="modal-label">What {{ feedbackType === 'like' ? 'did you like' : 'was the issue' }} about the
              response?</p>
            <div class="radio-group">
              <label class="radio-option">
                <input type="radio" name="issue_f" value="Data" [(ngModel)]="feedbackIssueType"
                  [disabled]="feedbackSubmitting" /> Data
              </label>
              <label class="radio-option">
                <input type="radio" name="issue_f" value="Graph" [(ngModel)]="feedbackIssueType"
                  [disabled]="feedbackSubmitting" /> Graph
              </label>
              <label class="radio-option">
                <input type="radio" name="issue_f" value="Response Summary" [(ngModel)]="feedbackIssueType"
                  [disabled]="feedbackSubmitting" /> Response Summary
              </label>
            </div>
          </div>

          <div class="modal-section">
            <p class="modal-label">How would you rate the response?</p>
            <div class="star-rating">
              <button *ngFor="let star of [1,2,3,4,5]" type="button" (click)="setFeedbackRating(star)"
                [disabled]="feedbackSubmitting" class="star-btn"
                [style.color]="star <= feedbackRating ? '#f59e0b' : '#d1d5db'"
                [style.opacity]="feedbackSubmitting ? '0.5' : '1'">
                &#9733;
              </button>
            </div>
          </div>

          <div class="modal-section-last">
            <p class="modal-label">Additional comments (optional)</p>
            <textarea [(ngModel)]="feedbackComments" rows="3" [disabled]="feedbackSubmitting"
              placeholder="Share details to improve future responses" class="modal-textarea"></textarea>
          </div>

          <div class="modal-actions">
            <button type="button" (click)="submitFeedback()" [disabled]="feedbackSubmitting || !canSubmitFeedback()"
              class="btn-primary" [style.opacity]="(feedbackSubmitting || !canSubmitFeedback()) ? '0.6' : '1'"
              [style.cursor]="(feedbackSubmitting || !canSubmitFeedback()) ? 'not-allowed' : 'pointer'">
              {{ feedbackSubmitting ? 'Submitting...' : 'Submit' }}
            </button>
            <button type="button" (click)="cancelFeedback()" [disabled]="feedbackSubmitting" class="btn-secondary"
              [style.opacity]="feedbackSubmitting ? '0.6' : '1'"
              [style.pointerEvents]="feedbackSubmitting ? 'none' : 'auto'">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- PROMPT HOME -->
    <ng-container *ngIf="!showNavSidebar && !fieldView">
      <div class="prompt-home-layout">
        <!-- Mobile overlay backdrop -->
        <div *ngIf="mobileSidebarOpen" class="sidebar-mobile-overlay" (click)="mobileSidebarOpen = false"></div>
        <div class="sidebar-wrapper" [ngClass]="mobileSidebarOpen ? 'open' : ''"
          style="background-color:#0B2D71;padding-top: 5vh;">
          <div class="sidebar-logo">
            <img src="assets/images/chevron-logo.png" alt="Chevron" />
          </div>



          <!-- User Metrics button - Show only if user has access -->
          <div *ngIf="hasMetricsAccess()" style="padding: 1.2vh 1vh">
            <button (click)="goToMetrics()"
              style="width: 100%; padding: 0.75rem 1rem; background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.04)); border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 0.625rem; color: white; cursor: pointer; font-size: 0.8rem; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 0.625rem; transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1); box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);"
              onmouseover="this.style.background='rgba(255, 255, 255, 0.12)'; this.style.borderColor='rgba(255, 255, 255, 0.35)'; this.style.boxShadow='0 4px 16px rgba(0, 0, 0, 0.2)'; this.style.transform='translateY(-2px)';"
              onmouseout="this.style.background='linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.04))'; this.style.borderColor='rgba(255, 255, 255, 0.2)'; this.style.boxShadow='0 2px 8px rgba(0, 0, 0, 0.1)'; this.style.transform='translateY(0px)';">
              <img src="assets/images/userMetrics.png" alt="Metrics"
                style="width: 1.1rem; height: 1.1rem; filter: brightness(0) invert(1); opacity: 0.9;" /> User Metrics
            </button>
          </div>

          <nav class="sidebar-nav">
            <div class="sidebar-history-section">
              <div class="history-label" style="font-size: 1.7vh;">Chat History</div>
              <div *ngIf="loadingHistory" class="history-loading">
                <img src="assets/images/spinner.png" alt="Loading..." class="spinner-icon" />
              </div>
              <p *ngIf="!loadingHistory && chatHistory.length === 0" class="history-empty" style="font-size: 1.5vh;">No
                history yet &#8212; ask a question in chat.</p>
              <div class="history-list">
                <button *ngFor="let c of chatHistory" type="button" (click)="loadChatHistoryEntry(c)"
                  style="border:none;cursor:pointer; font-size:1.5vh;"
                  [style.background]="activeHistoryId === c.id ? 'rgba(255,255,255,0.1)' : 'transparent'">
                  <span class="history-icon">&#x1F4AC;</span>

                  <span class="history-text" [title]="c.question">{{ truncateQuestion(c.question) }}</span>
                </button>
              </div>
            </div>
          </nav>
          <div class="sidebar-user">
            <div class="user-avatar">
              <img src="assets/images/userIcon.png" alt="User" class="user-icon" />
            </div>
            <div class="user-info">
              <p class="user-name" style="font-size: 1.8vh;">{{ currentUserDisplayName }}</p>
              <p class="user-role" style="font-size: 1.6vh;">Well Engineer</p>
            </div>
          </div>
        </div>
        <!-- Main content -->
        <div class="prompt-content">
          <header *ngIf="promptHome" class="prompt-header" style="background-color:#0B2D71;position: fixed; top: 0;">
            <button type="button" (click)="mobileSidebarOpen = !mobileSidebarOpen" class="menu-button">
              <span class="material-icon">☰</span>
            </button>
            <h1 style="font-size: 2.4vh; font-weight: 600; color: white; margin:0">
              Wells Lookback and Performance Insights
            </h1>
          </header>
          <div class="prompt-content-inner" style="padding-top: 13vh;">
            <div class="prompt-content-scroll" [style.padding]="promptHome ? '0' : '24px'">
              <div *ngIf="promptHome && promptPageError" class="prompt-error-banner">
                <span style="font-size:20px">⚠️</span>
                <div class="error-body">
                  <p class="error-title">Something went wrong</p>
                  <p class="error-detail">{{ promptPageError }}</p>
                </div>
                <button (click)="promptPageError = null" class="error-close"
                  style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;padding:2px">&#10005;</button>
              </div>
              <app-prompt-selection #promptSelectionView *ngIf="promptHome" (promptSelected)="onPromptSelected($event)"
                [parentComponent]="this"></app-prompt-selection>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- OVERVIEW WITH SIDEBAR (dashboard + chat) -->
    <ng-container *ngIf="showNavSidebar">
      <div class="overview-layout" style="height: 100vh;padding-top: 50px;">
        <!-- Dashboard panel -->
        <div class="dashboard-panel" style="border-radius: 1vh;">
          <header class="dashboard-header">
            <button type="button" (click)="mobileSidebarOpen = !mobileSidebarOpen" class="menu-button">
              <span class="material-icon">☰</span>
            </button>
            <div class="well-info">
              <ng-container *ngIf="!isMultiWellMode">
                <h2 class="well-name" style="margin:0">{{ wellHeaderInfo.name }}</h2>
                <p class="well-location" style="margin:0">{{ wellHeaderInfo.location }} &#183; {{ wellHeaderInfo.county
                  }}</p>
                <span class="status-badge" [ngClass]="isTechnicalResultMet() ? 'met' : 'not-met'">
                  <span class="status-dot" [ngClass]="isTechnicalResultMet() ? 'green' : 'red'"
                    style="text-transform: capitalize;"></span>
                  {{ capitalizeFirst(technicalResult) }}
                </span>
              </ng-container>
              <ng-container *ngIf="isMultiWellMode">
                <h2 class="well-name" style="margin:0">
                  Multi-Well -
                  <ng-container *ngIf="selectedSubTab === 'wells_summary'">Well Summary</ng-container>
                  <ng-container *ngIf="selectedSubTab === 'dashboard'">NPT Summary</ng-container>
                  <ng-container *ngIf="selectedSubTab === 'cost_performance'">Cost &amp; Performance</ng-container>
                  <ng-container *ngIf="selectedSubTab === 'lessons'">Lessons Learned</ng-container>
                </h2>
                <p class="well-location" style="margin:0">
                  {{ isMultiWellMode ? fieldWellIds.length : multiWellSelectedNames.length }} wells selected
                  <span *ngIf="selectedSubTab === 'dashboard' && apiNptSummary"
                    style="margin-left: 1.5vh; color: #991b1b; font-weight: 500;">
                    • {{ getWellsWithoutNptCount() }} {{ getWellsWithoutNptCount() === 1 ? 'well has' : 'wells have' }}
                    no NPT
                  </span>
                </p>
              </ng-container>
            </div>
            <!-- Header Actions: Data Quality Button and Download PDF Button -->
            <div class="header-actions">
              <!-- Download PDF Button (shown on all tabs) -->
              <button 
                type="button" 
                class="download-pdf-btn"
                (click)="downloadTabDataAsPdf()"
                [disabled]="downloadingPdf"
                title="Download PDF Report">
                               <img *ngIf="!downloadingPdf" src="assets/images/download.png" alt="Download" class="download-icon" />

                <img *ngIf="downloadingPdf" src="assets/images/spinner.png" alt="Loading" class="spinner-icon" style="width: 16px; height: 16px;" />
                {{ downloadingPdf ? 'Generating...' : 'Download PDF' }}
              </button>
              
              <!-- Data Quality Button (shown only for NPT Summary and Cost & Performance tabs) -->
              <button 
                *ngIf="selectedSubTab === 'dashboard' || selectedSubTab === 'cost_performance'"
                type="button" 
                class="data-quality-btn" 
                [ngClass]="getDataQualityButtonClass()"
                (click)="toggleDataQualityPopover()">
                <span class="material-icon">&#9432;</span>
                Data Quality
              </button>
              <!-- Data Quality Popover -->
              <div class="data-quality-popover" *ngIf="showDataQualityPopover && hasDataQuality()">
                <div class="popover-header">
                  <h3>Data Quality</h3>
                  <button type="button" class="close-btn" (click)="closeDataQualityPopover()">✕</button>
                </div>
                <div class="popover-content">
                  <!-- Single Well Mode -->
                  <ng-container *ngIf="!isMultiWellMode">

                    <div class="warnings-section">
                      <div class="quality-score-section">
                        <div class="score-label">Warnings</div>

                        <span class="quality-band-badge" [ngClass]="getDataQualityBand()">
                          {{ getDataQualityBand() === 'reliable' ? 'Reliable' : getDataQualityBand() === 'caution' ?
                          'Caution' : 'High Caution' }}
                        </span>
                      </div>
                      <div *ngIf="getDataQualityWarnings().length > 0" class="warnings-list">
                        <div *ngFor="let warning of getDataQualityWarnings()" class="warning-item">
                          <span class="warning-severity" [ngClass]="warning.severity">{{ warning.severity }}</span>
                          <div class="warning-text">
                            <p class="warning-message">{{ warning.message }}</p>
                           
                          </div>
                        </div>
                      </div>
                      <div *ngIf="getDataQualityWarnings().length === 0" class="no-warnings">
                        No data quality warnings
                      </div>
                    </div>
                  </ng-container>

                  <!-- Multi-Well Mode -->
                  <ng-container *ngIf="isMultiWellMode">
                    <div class="multi-well-quality">
                      <div *ngFor="let well of getMultiWellDataQuality()" class="well-quality-item">
                        <div class="well-quality-header">
                          <h4 class="well-name">{{ well.wellName }}</h4>
                          <div class="quality-score-section">

                            <span class="quality-band-badge" [ngClass]="well.band">
                              {{ well.band === 'reliable' ? 'Reliable' : well.band === 'caution' ? 'Caution' : 'High
                              Caution' }}
                            </span>
                          </div>
                        </div>
                        <div class="warnings-section">
                          <div *ngIf="well.warnings.length > 0" class="warnings-list">
                            <div *ngFor="let warning of well.warnings" class="warning-item">
                              <span class="warning-severity" [ngClass]="warning.severity">{{ warning.severity }}</span>
                              <div class="warning-text">
                                <p class="warning-message">{{ warning.message }}</p>
                               
                              </div>
                            </div>
                          </div>
                          <div *ngIf="well.warnings.length === 0" class="no-warnings">
                            No data quality warnings
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </header>
          <div #centerRef class="dashboard-content">
            <!-- Loading skeleton -->
            <ng-container *ngIf="loading">
              <div class="skeleton-spacer">
                <div class="skeleton-grid">
                  <div *ngFor="let i of [0,1,2]" class="skeleton-card"></div>
                </div>
                <div class="skeleton-bar" style="height: 14rem;"></div>
              </div>
            </ng-container>

            <!-- Wells Summary -->
            <ng-container *ngIf="selectedSection === 'overview' && selectedSubTab === 'wells_summary'">
              <div *ngIf="apiWellSummaryError && !loading" class="error-banner mb-5">
                <div class="error-inner">
                  <span class="error-icon" style="font-size:20px">⚠️</span>
                  <div class="error-body">
                    <p class="error-title">Failed to load well summary</p>
                    <p class="error-detail">{{ apiWellSummaryError }}</p>
                  </div>

                </div>
              </div>
              <ng-container *ngIf="!loading && !apiWellSummaryError">
                <ng-container *ngIf="!isMultiWellMode && !WELLS_SUMMARY_IDENTIFICATION">
                  <div style="padding: 40px 20px; text-align: center; color: #999;">
                    <p style="font-size: 14px; margin: 0;">No data available for selected well</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="isMultiWellMode && (!multiWellCards || multiWellCards.length === 0)">
                  <div style="padding: 40px 20px; text-align: center; color: #999;">
                    <p style="font-size: 14px; margin: 0;">No data available for selected wells</p>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="(isMultiWellMode && multiWellCards && multiWellCards.length > 0) || (!isMultiWellMode && WELLS_SUMMARY_IDENTIFICATION)">
                  <ng-container *ngIf="isMultiWellMode">
                    <div class="well-summary-stack">
                      <div class="summary-card well-summary-card" *ngFor="let w of multiWellCards; let i = index">
                        <div class="summary-card-header well-summary-header">
                          <h3>{{ w.name }}</h3>
                        </div>
                        <div class="summary-card-body">
                          <div class="well-detail-grid">
                            <div class="summary-row">
                              <p class="row-label">Field</p>
                              <p class="row-value">{{ w.field }}</p>
                            </div>
                            <div class="summary-row">
                              <p class="row-label">Area</p>
                              <p class="row-value">{{ w.area }}</p>
                            </div>
                            <div class="summary-row">
                              <p class="row-label">Job Type</p>
                              <p class="row-value">{{ w.jobType || '—' }}</p>
                            </div>
                            <div class="summary-row">
                              <p class="row-label">Abandonment Start</p>
                              <p class="row-value">{{ w.abandonmentStart }}</p>
                            </div>
                            <div class="summary-row">
                              <p class="row-label">Abandonment End</p>
                              <p class="row-value">{{ w.abandonmentEnd }}</p>
                            </div>
                          </div>
                          <details class="history-details">
                            <summary class="history-disclosure">
                              <span class="history-disclosure-icon" aria-hidden="true"></span>
                              <span class="history-disclosure-label">Well History</span>
                              <span class="history-disclosure-count">{{ multiWellSummaryData[i]?.PriorJobs?.length || 0 }} jobs</span>
                            </summary>
                            <div class="history-timeline">
                              <div *ngFor="let j of (multiWellSummaryData[i]?.PriorJobs || []); let last = last" class="history-item" [class.last]="last">
                                <span class="history-dot"></span>
                                <div class="history-content">
                                  <div class="history-field">
                                    <span class="history-field-label">Job Start Date</span>
                                    <span class="history-date">{{ formatJobDate(j.JobStartDate) || 'Date not provided' }}</span>
                                  </div>
                                  <div class="history-field">
                                    <span class="history-field-label">Primary Job Type</span>
                                    <span class="history-type">{{ j.PrimaryJobType || 'Type not provided' }}</span>
                                  </div>
                                </div>
                              </div>
                              <p *ngIf="!(multiWellSummaryData[i]?.PriorJobs?.length)" class="history-empty">No well history available</p>
                            </div>
                          </details>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="!isMultiWellMode">
                    <div class="summary-cards-grid">
                      <div class="summary-card">
                        <div class="summary-card-header">
                          <h3>Well Identification</h3>
                        </div>
                        <div class="summary-card-body">
                          <div *ngFor="let row of WELLS_SUMMARY_IDENTIFICATION" class="summary-row">
                            <p class="row-label">{{ row.label }}</p>
                            <p class="row-value">{{ row.value }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="summary-card">
                        <div class="summary-card-header">
                          <h3>Well Background</h3>
                        </div>
                        <div class="summary-card-body">
                          <div *ngFor="let row of WELLS_SUMMARY_BACKGROUND_FIELDS" class="summary-row">
                            <p class="row-label">{{ row.label }}</p>
                            <p class="row-value">{{ row.value }}</p>
                          </div>
                          <div *ngFor="let block of WELLS_SUMMARY_BACKGROUND_LISTS" class="summary-list-block">
                            <p class="list-title">{{ block.title }}</p>
                            <ul>
                              <li *ngFor="let item of block.items">{{ item }}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="summary-card">
                        <div class="summary-card-header">
                          <h3>Job Identification</h3>
                        </div>
                        <div class="summary-card-body">
                          <div *ngFor="let field of WELLS_SUMMARY_JOB_IDENTIFICATION" class="summary-row">
                            <p class="row-label">{{ field.label }}</p>
                            <p class="row-value">{{ field.value }}</p>
                          </div>

                          <button type="button" class="history-disclosure" [class.open]="showSingleWellHistory" [attr.aria-expanded]="showSingleWellHistory" (click)="showSingleWellHistory = !showSingleWellHistory">
                            <span class="history-disclosure-icon">{{ showSingleWellHistory ? '▾' : '▸' }}</span>
                            <span class="history-disclosure-label">Well History</span>
                            <span class="history-disclosure-count">{{ WELL_HISTORY_SINGLE.length }} jobs</span>
                          </button>

                          <div *ngIf="showSingleWellHistory" class="history-timeline">
                            <div *ngFor="let h of WELL_HISTORY_SINGLE; let last = last" class="history-item" [class.last]="last">
                              <span class="history-dot"></span>
                              <div class="history-content">
                                <div class="history-field">
                                  <span class="history-field-label">Job Start Date</span>
                                  <span class="history-date">{{ h.jobStartDate }}</span>
                                </div>
                                <div class="history-field">
                                  <span class="history-field-label">Primary Job Type</span>
                                  <span class="history-type">{{ h.primaryJobType }}</span>
                                </div>
                              </div>
                            </div>
                            <p *ngIf="WELL_HISTORY_SINGLE.length === 0" class="history-empty">No well history available</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- Overview Dashboard (NPT Summary) -->
            <ng-container *ngIf="selectedSection === 'overview' && selectedSubTab === 'dashboard'">
              <div *ngIf="apiNptLoading" class="skeleton-spacer">
                <div class="skeleton-grid">
                  <div *ngFor="let i of [0,1,2]" class="skeleton-card"></div>
                </div>
                <div class="skeleton-bar" style="height: 14rem;"></div>
              </div>
              <div *ngIf="apiNptError && !apiNptLoading" class="error-banner">
                <div class="error-inner">
                  <span class="error-icon" style="font-size:20px">⚠️</span>
                  <div class="error-body">
                    <p class="error-title">Failed to load NPT data</p>
                    <p class="error-detail">{{ apiNptError }}</p>
                  </div>

                </div>
              </div>
              <ng-container *ngIf="!apiNptLoading && !apiNptError">
                <ng-container
                  *ngIf="!isMultiWellMode && (!OVERVIEW_NPT_TOTAL_HRS || OVERVIEW_NPT_TOTAL_HRS === 0) && (!NPT_EVENTS || NPT_EVENTS.length === 0)">
                  <div style="padding: 40px 20px; text-align: center; color: #999;">
                    <p style="font-size: 14px; margin: 0;">No data available for selected well</p>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="isMultiWellMode && (!multiWellTotalNptHrs || multiWellTotalNptHrs === 0) && (!multiWellNptEvents || multiWellNptEvents.length === 0)">
                  <div style="padding: 40px 20px; text-align: center; color: #999;">
                    <p style="font-size: 14px; margin: 0;">No data available for selected wells</p>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="(isMultiWellMode && multiWellTotalNptHrs && multiWellTotalNptHrs > 0) || (!isMultiWellMode && OVERVIEW_NPT_TOTAL_HRS && OVERVIEW_NPT_TOTAL_HRS > 0) || (isMultiWellMode && multiWellNptEvents && multiWellNptEvents.length > 0) || (!isMultiWellMode && NPT_EVENTS && NPT_EVENTS.length > 0)">
                  <app-npt-summary-tab [isMultiWellMode]="isMultiWellMode" [multiWellTotalHrs]="multiWellTotalHrs"
                    [multiWellTotalNptHrs]="multiWellTotalNptHrs" [multiWellTotalNptCost]="multiWellTotalNptCost"
                    [multiWellNptEvents]="multiWellNptEvents" [multiWellCausalAnalysis]="multiWellCausalAnalysis"
                    [multiWellSelectedNames]="multiWellSelectedNames" [wellNameMap]="wellNameMap"
                    [wellsWithoutNptEvents]="wellsWithoutNptEvents"
                    [originalSelectedWellsCount]="originalSelectedWellsCount"
                    [selectedWellForTimeLog]="selectedWellForTimeLog" [totalPaDurationHrs]="totalPnaDuration"
                    [paDurationDays]="paDurationDays" [nptTotalHrs]="OVERVIEW_NPT_TOTAL_HRS" [nptPct]="OVERVIEW_NPT_PCT"
                    [nptCost]="nptTotalCost()" [nptEvents]="NPT_EVENTS" [causalAnalysis]="ACTIVE_WELL_CAUSAL_ANALYSIS"
                    [showTimeLog]="showTimeLog" [activeWellName]="ACTIVE_WELL_NAME"
                    [activeWellTimeLog]="ACTIVE_WELL_TIME_LOG" [currentWellId]="activeWell?.id || ''"
                    [loadingTimeLog]="apiTimeLogLoading" [apiTimeLogError]="apiTimeLogError"
                    [apiRcaLoading]="apiRcaLoading" [hasRcaAccess]="hasRcaAccess"
                    (toggleTimeLog)="showTimeLog = !showTimeLog; loadTimeLog()"
                    (toggleDailyOps)="toggleDailyOps()" (closeDailyOps)="closeDailyOps()"
                    [showDailyOps]="showDailyOps" [dailyOpsRows]="apiDailyOpsRows"
                    [selectedWellForDailyOps]="selectedWellForDailyOps" (selectWellForDailyOps)="selectWellForDailyOps($event)"
                    [dailyOpsWells]="DAILY_OPS_WELLS"
                    [dailyOpsLoading]="apiDailyOpsLoading" [dailyOpsError]="apiDailyOpsError"
                    (closeTimeLog)="showTimeLog = false; selectedWellForTimeLog = null; apiTimeLog = []; apiTimeLogError = null;"
                    (selectWellForTimeLog)="selectWellForTimeLog($event)" (loadTimeLogRetry)="loadTimeLog($event)"
                    (submitRcaFeedback)="submitRcaFeedback($event)">
                  </app-npt-summary-tab>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- Cost Performance -->
            <ng-container *ngIf="selectedSection === 'cost' && selectedSubTab === 'cost_performance'">
              <div *ngIf="apiPerformanceError && !apiPerformanceLoading" class="error-banner mb-5">
                <div class="error-inner">
                  <span class="error-icon" style="font-size:20px">⚠️</span>
                  <div class="error-body">
                    <p class="error-title">Failed to load performance data</p>
                    <p class="error-detail">{{ apiPerformanceError }}</p>
                  </div>

                </div>
              </div>
              <div *ngIf="apiPerformanceLoading" class="skeleton-spacer">
                <div class="kpi-skeleton-grid">
                  <div class="kpi-skeleton">
                    <div class="skel-line sm"></div>
                    <div class="skel-line lg"></div>
                    <div class="skel-line md"></div>
                  </div>
                  <div class="kpi-skeleton">
                    <div class="skel-line sm"></div>
                    <div class="skel-line lg"></div>
                    <div class="skel-line md"></div>
                  </div>
                  <div class="kpi-skeleton">
                    <div class="skel-line sm"></div>
                    <div class="skel-line lg"></div>
                    <div class="skel-line md"></div>
                  </div>
                </div>
                <div class="table-skeleton">
                  <div class="skel-title"></div>
                  <div class="skel-rows">
                    <div class="skel-row dark"></div>
                    <div class="skel-row light"></div>
                    <div class="skel-row light"></div>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="!apiPerformanceLoading && !apiPerformanceError">
                <ng-container *ngIf="!isMultiWellMode && !COST_DATA">
                  <div style="padding: 40px 20px; text-align: center; color: #999;">
                    <p style="font-size: 14px; margin: 0;">No data available for selected well</p>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="isMultiWellMode && (!apiPerformance || (Array.isArray(apiPerformance) && apiPerformance.length === 0))">
                  <div style="padding: 40px 20px; text-align: center; color: #999;">
                    <p style="font-size: 14px; margin: 0;">No data available for selected wells</p>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="(isMultiWellMode && apiPerformance && Array.isArray(apiPerformance) && apiPerformance.length > 0) || (!isMultiWellMode && COST_DATA)">
                  <app-cost-performance-tab [isMultiWellMode]="isMultiWellMode" [COST_DATA]="COST_DATA"
                    [PHASE_WISE]="PHASE_WISE" [multiWellPhaseGrouped]="multiWellPhaseGrouped"
                    [multiWellTotalPlannedAFE]="multiWellTotalPlannedAFE"
                    [multiWellTotalActualCost]="multiWellTotalActualCost"
                    [multiWellTotalVariance]="multiWellTotalVariance" [OVERVIEW_NPT_TOTAL_HRS]="costPerfNptHours"
                    [OVERVIEW_NPT_PCT]="costPerfNptPct" [multiWellTotalNptHrs]="multiWellTotalNptHrs"
                    [singleWellTotalNptCost]="costPerfNptCost" [multiWellTotalNptCost]="multiWellTotalNptCost"
                    [multiWellTotalHrs]="multiWellTotalHrs" [multiWellCostSummary]="multiWellCostSummary">
                  </app-cost-performance-tab>
                </ng-container>
              </ng-container>
              <div *ngIf="false" class="skeleton-spacer">
              </div>
            </ng-container>

            <!-- Lessons Learnt -->
            <ng-container *ngIf="!loading && isSection('lessons')">
              <app-lessons-tab [isMultiWellMode]="isMultiWellMode" [LESSONS]="LESSONS"
                [multiWellLessonsByWell]="multiWellLessonsByWell" [apiLessonsReport]="apiLessonsReport"
                [apiLessonsLoading]="apiLessonsLoading" [apiLessonsError]="apiLessonsError"
                [apiLessonsData]="apiLessonsData">
              </app-lessons-tab>
            </ng-container>

          </div>
        </div>

        <!-- Chat panel - desktop: inline, mobile: floating popover -->
        <button *ngIf="!mobileChatOpen" type="button" (click)="openMobileChat()" class="chat-fab"
          style="background:linear-gradient(135deg, #0B2D71, #072050);border:none;cursor:pointer;font-size:24px">
          💬
        </button>

        <div *ngIf="mobileChatOpen" class="chat-overlay" (click)="mobileChatOpen = false"></div>

        <div class="chat-resize-handle" (mousedown)="startChatResize($event)" title="Drag to resize chat panel">
          <div class="handle-grip"></div>
        </div>
        <div class="chat-panel-container" [ngClass]="mobileChatOpen ? 'mobile-open' : ''"
          [style.width]="mobileChatOpen ? '' : chatPanelWidth + 'px'" [style.min-width]="mobileChatOpen ? '' : '280px'"
          [style.max-width]="mobileChatOpen ? '' : '65%'" style="border-radius: 1vh; flex-shrink: 0;">
          <div class="chat-panel-inner">
            <!-- Chat Header -->
            <div class="chat-header">
              <div class="bot-avatar" style="background:linear-gradient(135deg, #0B2D71, #072050)">
                <img src="assets/images/sparkle.png" alt="AI" class="icon-image" />
              </div>
              <div class="header-text">
                <p class="header-title" style="margin:0">P&amp;A Insights Agent</p>
                <p class="chat-subtitle" style="margin:0">
                  <ng-container *ngIf="(activeWell?.WellName || apiWellSummary?.WellName)">
                    {{ activeWell?.WellName || apiWellSummary?.WellName }}
                    <ng-container *ngIf="activeWell?.FieldName || apiWellSummary?.FieldName"> &bull; {{
                      activeWell?.FieldName || apiWellSummary?.FieldName }}</ng-container>
                  </ng-container>
                  <ng-container *ngIf="!(activeWell?.WellName || apiWellSummary?.WellName)">
                    {{ activeWell?.name || '' }}<ng-container *ngIf="activeWell?.location"> &bull; {{
                      activeWell.location }}</ng-container>
                  </ng-container>
                </p>
              </div>
              <button type="button" (click)="mobileChatOpen = false" class="chat-close-btn"
                style="background:none;border:none;cursor:pointer">
                ✕
              </button>
            </div>

            <!-- Chat Messages -->
            <div #wellChatMessages class="chat-messages" style="font-size:13px;line-height:1.6">

              <div *ngIf="messages.length === 0 && !chatLoading" class="chat-empty-start">
              </div>

              <div *ngFor="let m of messages; let msgIdx = index" class="message-row"
                [style.justifyContent]="m.role === 'user' ? 'flex-end' : 'flex-start'">

                <div *ngIf="m.role === 'assistant'" class="message-avatar"
                  style="background:linear-gradient(135deg, #0B2D71, #072050)">
                  <img src="assets/images/BotIcon.png" alt="Bot" class="icon-image" />
                </div> <ng-container *ngIf="m.role === 'assistant'">
                  <div class="message-content-wrapper" style="position:relative">
                    <div *ngIf="m.isError" class="message-bubble assistant-bubble error"
                      style="font-size:13px;line-height:1.6;border-radius:1rem 1rem 1rem 0.125rem">
                      <p style="margin:0 0 6px 0; font-weight:600">&#9888;&#65039; Error:</p>
                      <div [innerHTML]="formatMarkdownToHtml(m.content)"></div>
                    </div>

                    <div *ngIf="!m.isError" class="message-bubble assistant-bubble"
                      style="font-size:13px;line-height:1.6;border-radius:1rem 1rem 1rem 0.125rem">
                      <div [innerHTML]="formatMarkdownToHtml(m.content)"></div>
                    </div>

                    <div *ngIf="m.results && m.results.length > 0 && !m.isError" class="results-container">
                      <div *ngIf="m.visualization && m.visualization.viz_type !== 'kpi_cards' && m.chartOptions"
                        class="viz-toggle-bar">
                        <div class="viz-toggle-group">
                          <button (click)="toggleViewMode(m, 'table')" class="viz-toggle-btn"
                            [ngClass]="m.viewMode === 'table' ? 'active' : ''">
                            <img src="assets/images/tableIcon.png" alt="Table" class="viz-icon" />
                            Table
                          </button>
                          <button (click)="toggleViewMode(m, 'chart')" class="viz-toggle-btn"
                            [ngClass]="m.viewMode === 'chart' ? 'active' : ''">
                            <img src="assets/images/chartIcon.png" alt="Chart" class="viz-icon" />
                            Chart
                          </button>
                        </div>
                        <span class="viz-title">{{ m.visualization.title }}</span>
                      </div>

                      <div *ngIf="!m.visualization || m.viewMode === 'table'" class="results-table-wrapper compact">
                        <div class="thin-scrollbar"
                          style="max-height: 400px; scrollbar-width: thin; scrollbar-color: #0B2D71 #f3f4f6;">
                          <table class="results-table compact">
                            <thead style="position: sticky; top: 0; z-index: 10;">
                              <tr style="background:#0B2D71">
                                <th *ngFor="let col of resultColumns(m.results)"
                                  style="font-size:11px;letter-spacing:0.03em">
                                  {{ col }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let row of m.results; let i = index">
                                <td *ngFor="let col of resultColumns(m.results)">
                                  {{ formatCellValue(row[col]) }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="results-footer compact">
                          <span>Total: {{ m.results.length }} row{{ m.results.length !== 1 ? 's' : '' }}</span>
                        </div>
                      </div>

                      <div *ngIf="m.visualization && m.viewMode === 'chart'"
                        class="chart-wrapper compact thin-scrollbar">
                        <div class="chart-inner">
                          <highcharts-chart [Highcharts]="Highcharts" [options]="m.chartOptions"
                            style="width: 100%; height: 480px; display: block;">
                          </highcharts-chart>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="!chatLoading && !m.isWelcomeMessage && isProperResponse(m)" class="feedback-pill">
                      <button type="button" (click)="openFeedbackModal(msgIdx, 'like')" class="feedback-btn"
                        [class.active]="m.feedbackType === 'like'" style="background:none;border:none;cursor:pointer"
                        [style.opacity]="m.feedbackType === 'like' ? '1' : '0.5'" title="Helpful">
                        <img src="assets/images/like.png" alt="Like" class="feedback-icon" />
                      </button>
                      <button type="button" (click)="openFeedbackModal(msgIdx, 'dislike')" class="feedback-btn"
                        [class.active]="m.feedbackType === 'dislike'" style="background:none;border:none;cursor:pointer"
                        [style.opacity]="m.feedbackType === 'dislike' ? '1' : '0.5'" title="Not helpful">
                        <img src="assets/images/dislike.png" alt="Dislike" class="feedback-icon" />
                      </button>
                      <div class="feedback-divider"></div>
                      <button type="button" (click)="exportResponseToPdf(msgIdx)" class="feedback-btn download"
                        style="background:none;border:none;cursor:pointer" title="Download PDF">
                        <img src="assets/images/download.png" alt="Download" class="feedback-icon" />
                      </button>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="m.role === 'user'">
                  <div class="message-bubble user-bubble"
                    style="background:#0B2D71;color:#fff;font-size:13px;line-height:1.6;border-radius:1rem 1rem 0.125rem 1rem">
                    {{ m.content }}
                  </div>
                </ng-container>

                <div *ngIf="m.role === 'user'" class="message-avatar-sm">
                  <img src="assets/images/chatUser.png" alt="User" class="icon-image-user" />
                </div>
              </div>

              <div *ngIf="chatLoading" class="loading-row">
                <div class="message-avatar" style="background:linear-gradient(135deg, #0B2D71, #072050)">
                  <img src="assets/images/BotIcon.png" alt="Bot" class="icon-image" />
                </div>
                <div class="loading-dots">
                  <div *ngFor="let j of [0,1,2]" class="dot" [style.animationDelay]="j * 150 + 'ms'"></div>
                </div>
              </div>
            </div>

            <!-- Chat Input -->
            <form class="chat-input-form" (submit)="$event.preventDefault(); handleChatSend()">
              <div class="input-wrapper">
                <input type="text" [(ngModel)]="chatDraft" name="wellChatInput"
                  style="appearance: none; -webkit-appearance: none; -moz-appearance: none;"
                  placeholder="Ask about this well..." (keydown.enter)="$event.preventDefault(); handleChatSend()" />
                <button type="submit" [disabled]="chatLoading || !chatDraft.trim()" class="send-btn"
                  style="border:none;cursor:pointer;background:#0B2D71;width:32px;height:32px;min-width:32px;min-height:32px;padding:0"
                  aria-label="Send">
                  ➤
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<!-- Feedback Survey Modal (well-level chat) -->
<div *ngIf="showFeedbackModal" class="modal-overlay" style="background:rgba(0,0,0,0.4)">
  <div class="modal-card" style="font-family:'Inter',system-ui,sans-serif">
    <h2 class="modal-title">Quick Feedback</h2>

    <div *ngIf="feedbackError" class="modal-error">
      <p>{{ feedbackError }}</p>
    </div>

    <div class="modal-section">
      <p class="modal-label">What {{ feedbackType === 'like' ? 'did you like' : 'was the issue' }} about the response?
      </p>
      <div class="radio-group">
        <label class="radio-option">
          <input type="radio" name="issue_w" value="Data" [(ngModel)]="feedbackIssueType"
            [disabled]="feedbackSubmitting" /> Data
        </label>
        <label class="radio-option">
          <input type="radio" name="issue_w" value="Graph" [(ngModel)]="feedbackIssueType"
            [disabled]="feedbackSubmitting" /> Graph
        </label>
        <label class="radio-option">
          <input type="radio" name="issue_w" value="Response Summary" [(ngModel)]="feedbackIssueType"
            [disabled]="feedbackSubmitting" /> Response Summary
        </label>
      </div>
    </div>

    <div class="modal-section">
      <p class="modal-label">How would you rate the response?</p>
      <div class="star-rating">
        <button *ngFor="let star of [1,2,3,4,5]" type="button" (click)="setFeedbackRating(star)"
          [disabled]="feedbackSubmitting" class="star-btn"
          [style.color]="star <= feedbackRating ? '#f59e0b' : '#d1d5db'"
          [style.opacity]="feedbackSubmitting ? '0.5' : '1'">
          &#9733;
        </button>
      </div>
    </div>

    <div class="modal-section-last">
      <p class="modal-label">Additional comments (optional)</p>
      <textarea [(ngModel)]="feedbackComments" rows="3" [disabled]="feedbackSubmitting"
        placeholder="Share details to improve future responses" class="modal-textarea"></textarea>
    </div>

    <div class="modal-actions">
      <button type="button" (click)="submitFeedback()" [disabled]="feedbackSubmitting || !canSubmitFeedback()"
        class="btn-primary" [style.opacity]="(feedbackSubmitting || !canSubmitFeedback()) ? '0.6' : '1'"
        [style.cursor]="(feedbackSubmitting || !canSubmitFeedback()) ? 'not-allowed' : 'pointer'">
        {{ feedbackSubmitting ? 'Submitting...' : 'Submit' }}
      </button>
      <button type="button" (click)="cancelFeedback()" [disabled]="feedbackSubmitting" class="btn-secondary"
        [style.opacity]="feedbackSubmitting ? '0.6' : '1'" [style.pointerEvents]="feedbackSubmitting ? 'none' : 'auto'">
        Cancel
      </button>
    </div>
  </div>
</div>